import { CmpApi } from '@iabtcf/cmpapi';

import tcModel, { getTCString, shouldAllowAllVendors } from './tc-model';
import config from './config';

import { setTCStringCookie } from './cookieutils';

// cmpApi surfaces the TC string to allowed vendors
const cmpApi = new CmpApi(
  config.cmpId,
  config.cmpVersion,
  config.isSpecificService
);

// Updates cmp api tc string and consent cookie
function update() {
  const tcString = getTCString();

  // Update cmpApi so tcstring is accesible publicly through __tcfapi
  cmpApi.update(tcString);

  // Save tcstring cookie for next visit
  setTCStringCookie(tcString);
}

// Accepts all supported consents, legitimate interests, and vendors
export function acceptAll() {
  tcModel.vendorConsents.set(config.vendorIds);
  // Accept supported consent and legitimiate interests only
  tcModel.purposeConsents.set(config.consentIds);
  tcModel.purposeLegitimateInterests.set(config.legitimateInterestIds);
  update();
}

export function rejectAll() {
  tcModel.unsetAll();
  update();
}

export function save() {
  if (shouldAllowAllVendors()) {
    tcModel.setAllVendorConsents();
  }
  update();
}
